//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import handleErrorMixin from '@/mixins/handleErrorMixin'
import SidebarCollaborators from '../../Sidebar/SidebarCollaborators.vue'
import HeaderStepSkills from './HeaderStepSkills.vue'
import ValidationSkillsSection from './ValidationSkillsSection.vue'
import CollaboratorCount from './CollaboratorCount.vue'
import ValidationSkills from './ValidationSkills.vue'
import ModalValidationConfirmation from './ModalValidationConfirmation.vue'
import Notification from './Notification.vue'
import HeaderValidation from '~/components/Validation/HeaderValidation.vue'
import Button from '~/components/Shared/Button.vue'
import ValidationContainer from '~/components/Validation/ValidationContainer.vue'
import ASSIGMENT_VALIDATION_STATUS from '~/constants/assigment-validation-status.js'
import { showErrorNotification } from '~/util/notifications'

export default {
  components: {
    Button,
    ValidationContainer,
    SidebarCollaborators,
    HeaderStepSkills,
    ValidationSkillsSection,
    CollaboratorCount,
    ValidationSkills,
    ModalValidationConfirmation,
    Notification,
    HeaderValidation,
  },
  mixins: [handleErrorMixin],
  props: {
    projectId: {
      type: Number,
      required: true,
    },
    projectRoleId: {
      type: Number,
      required: true,
    },
    showNotificationChanges: {
      type: Boolean,
      default: false,
    },
    assignments: {
      type: Array,
      default: () => [],
    },
  },
  async fetch() {
    this.setCurrentValidationId()
    await this.setValidationSkills(this.currentValidationId)
  },
  data() {
    return {
      isExpanded: false,
      currentValidationId: null,
      validationSkills: [],
      isVisibleModalConfirmation: false,
      showPendingValidationSkillsIndicator: false,
      saving: false,
      showSidebarCollaborators: false,
      proccessNext: false,
    }
  },
  computed: {
    isEnabledButtonNext() {
      return this.validationSkills.length > 0 && !this.proccessNext
    },
    userSkillsHas() {
      return this.validationSkills.filter((skill) => skill.user_has_skill)
    },
    userSkillsNotHas() {
      return this.validationSkills.filter((skill) => !skill.user_has_skill)
    },
    currentAssignment() {
      return this.assignments.find(
        (assignment) => assignment.id === this.currentValidationId
      )
    },
    progressCount() {
      return (
        this.assignments.findIndex(
          (assignment) => assignment.id === this.currentValidationId
        ) + 1
      )
    },
    isPendingValidationSkills() {
      return (
        this.validationSkills.some(
          (skill) => skill.supervisor_validate_skill == null
        ) || this.validationSkills.length === 0
      )
    },
    isLastValidation() {
      return (
        this.currentValidationId ===
        this.assignments[this.assignments.length - 1]?.id
      )
    },
    userId() {
      return this.$strapi.user.id
    },
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    toogleModalConfirmation() {
      this.isVisibleModalConfirmation = !this.isVisibleModalConfirmation
    },
    resize() {
      this.isExpanded = window.innerWidth <= 435
    },
    setCurrentValidationId() {
      this.currentValidationId =
        this.assignments.find(
          (assignment) =>
            assignment.validation_status ===
            ASSIGMENT_VALIDATION_STATUS.IN_PROGRESS
        )?.id ||
        this.assignments.find(
          (assignment) =>
            assignment.validation_status ===
            ASSIGMENT_VALIDATION_STATUS.READY_FOR_VALIDATION
        )?.id ||
        this.assignments.find(
          (assignment) =>
            assignment.validation_status ===
            ASSIGMENT_VALIDATION_STATUS.FINISHED
        )?.id ||
        this.assignments[0]?.id
    },
    async setValidationSkills(assigmentId) {
      this.validationSkills = []
      if (
        [
          ASSIGMENT_VALIDATION_STATUS.READY_FOR_VALIDATION,
          ASSIGMENT_VALIDATION_STATUS.IN_PROGRESS,
          ASSIGMENT_VALIDATION_STATUS.FINISHED,
        ].includes(this.currentAssignment.validation_status)
      ) {
        this.validationSkills = await this.getValidationSkills(assigmentId)
      }
    },
    async getValidationSkills(assigmentId) {
      try {
        this.$store.commit('loading', true)
        return await this.$repository.skillsValidations.findToAssignmentId(
          assigmentId
        )
      } catch (error) {
        this.handleErrorMixin.handleError(
          error,
          'Ocurrió un error al cargar las habilidades de validación'
        )
      } finally {
        this.$store.commit('loading', false)
      }
    },
    handleUpdateSkill(skill) {
      this.validationSkills = this.validationSkills.map((sk) => {
        if (sk.id === skill.id) {
          return {
            ...sk,
            supervisor_validate_skill: skill.supervisor_validate_skill,
            collaborator_has_skill: skill.user_has_skill,
          }
        }
        return sk
      })
      this.updateAssigmentStatus()
      this.$emit('saving', false)
    },
    handleSaving(value) {
      this.saving = value
    },

    async updateAssigmentStatus() {
      if (
        this.currentAssignment.validation_status ===
        ASSIGMENT_VALIDATION_STATUS.READY_FOR_VALIDATION
      ) {
        await this.$repository.supervisorAssignments.updateStatus(
          this.currentAssignment.id,
          ASSIGMENT_VALIDATION_STATUS.IN_PROGRESS
        )
      }
    },
    async handleNext() {
      this.proccessNext = true
      try {
        if (this.isPendingValidationSkills) {
          this.showPendingValidationSkillsIndicator = true
          showErrorNotification(
            this,
            'Hay campos que aún no has completado',
            3000
          )
          this.proccessNext = false
          return
        }
        this.showPendingValidationSkillsIndicator = false
        this.$store.commit('loading', true)
        if (this.isLastValidation) {
          this.toogleModalConfirmation()
        } else {
          await this.finishCurrentAssignment()
          const currentIndex = this.assignments.findIndex(
            (assignment) => assignment.id === this.currentValidationId
          )
          this.currentValidationId = this.assignments[currentIndex + 1]?.id
          await this.inProgressCurrentAssignment()
          this.setValidationSkills(this.currentValidationId)
        }
      } catch (error) {
        this.handleError(error, 'Ocurrió un error')
      } finally {
        this.$store.commit('loading', false)
        this.proccessNext = false
      }
    },
    async handleConfirmValidation() {
      try {
        this.$store.commit('loading', true)
        await this.finishCurrentAssignment()
        this.$emit('next')
      } catch (error) {
        this.handleError(error, 'Ocurrió un error al confirmar la validación')
      } finally {
        this.$store.commit('loading', false)
        this.toogleModalConfirmation()
      }
    },
    async inProgressCurrentAssignment() {
      await this.$repository.supervisorAssignments.updateStatus(
        this.currentAssignment.id,
        ASSIGMENT_VALIDATION_STATUS.IN_PROGRESS
      )
      this.updateAssigmentInAssignments(
        this.currentAssignment.id,
        ASSIGMENT_VALIDATION_STATUS.IN_PROGRESS
      )
    },
    async finishCurrentAssignment() {
      await this.$repository.supervisorAssignments.updateStatus(
        this.currentAssignment.id,
        ASSIGMENT_VALIDATION_STATUS.FINISHED
      )
      this.updateAssigmentInAssignments(
        this.currentAssignment.id,
        ASSIGMENT_VALIDATION_STATUS.FINISHED
      )
      await this.$repository.projectRoles.updateValidationStatus(
        this.projectId,
        this.userId
      )
      await this.$repository.supervisorAssignments.matchSupervisorAssignment(
        this.currentAssignment.id
      )
    },
    updateAssigmentInAssignments(id, status) {
      this.assignments = this.assignments.map((assignment) => {
        if (assignment.id === id) {
          return {
            ...assignment,
            validation_status: status,
          }
        }
        return assignment
      })
    },
    handleSelectCollaborator(assignment) {
      this.currentValidationId = assignment.id
      this.setValidationSkills(assignment.id)
    },
  },
}
